export const {
  REACT_APP_AUTH_TOKEN: AUTH_TOKEN,
  REACT_APP_BE_URL: API_URL,
  REACT_APP_STRIPE_CLIENT_ID: STRIPE_CLIENT_ID,
  REACT_APP_STRIPE_ONBOARDING_RETURN_PATH: STRIPE_ONBOARDING_RETURN_PATH,
  REACT_APP_SUPPORT_EMAIL_ADDRESS: SUPPORT_EMAIL_ADDRESS,
} = process.env;
